
import { AppBar, Box, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody, Checkbox, Tooltip, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, useScrollTrigger, Slide, CssBaseline, Container, Grid, Card, CardContent } from "@mui/material";
import React, { useState, useEffect } from "react";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Searchicon from '@mui/icons-material/Search';

// import './../../purchases/boxstyles.css';



import AddNewSalaryStructure from "./NewSalaryStructure";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";



const SalaryStructure = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Salary Structure');
    const openFirst = Boolean(anchorElFirst);
    const [newVendor, setNewVendor] = useState(false);
    const [vendorHome, setVendorHome] = useState(true);
    const [open, setOpen] = useState(false);

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isDataSalaryComponentLoaded, setIsDataSalaryComponentLoaded] = useState(false);
    const [employeeDetails, setemployeeDetails] = useState([]);
    const [partyList, setPartyList] = useState([]);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openSecond = Boolean(anchorElSecond);

    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('All');

    const [editSalaryStructureID, setEditSalaryStructureID] = useState(0);
    const [editSalaryStructureCode, setEditSalaryStructureCode] = useState('');


    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Salary Structure') {
            setSelectedStatus('All');
        }
        else if (option === 'Active Salary Structure') {
            setSelectedStatus('Active');
        }
        else if (option === 'Inactive Salary Structure') {
            setSelectedStatus('InActive');
        }

        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setEditSalaryStructureID(0);
        setVendorHome(false);
        setNewVendor(true);
    }

    const handlecallback = () => {
        setEditSalaryStructureID(0);
        setEditSalaryStructureCode('');
        setVendorHome(true);
        setNewVendor(false);

        const para = { p_companyid:  localStorage.getItem('companyid'), }

        callApi(API_ENDPOINTS.SALARY_STRUCTURE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => setPartyList(Array.isArray(data) ? data : []))
            .catch(error => alert(error.message));
    }

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.Example_Employee_form, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data?.length > 0) {
                        setemployeeDetails(data);
                    }
                    else {
                        setemployeeDetails([]);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);




    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.SALARY_STRUCTURE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPartyList(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);







    const [filters, setFilters] = useState({
        name: '',
        companyname: '',
        email: '',
        workphone: '',
        status: '',
        payales: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = partyList.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };
    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);


    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;




    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    const handleCallEdit = (value,value1) => {
        setEditSalaryStructureID(value);
        setEditSalaryStructureCode(value1);
        setVendorHome(false);
        setNewVendor(true);

    };




    return (
        <Box sx={{ marginTop: "0px" }}>
            <CssBaseline />
            {vendorHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}

                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('All Salary Structure')}>All Salary Structure</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Active Salary Structure')}>Active Salary Structure</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Inactive Salary Structure')}>Inactive Salary Structure</MenuItem>
                        </Menu>

                        {/* Adding margin-left: auto to push the button to the right */}
                        <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Vendors" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Vendors" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon sx={{ fontSize: "18px" }} />
                        </IconButton>

                        <div>
                            <IconButton onClick={handleBackWinderMachineEntry} >
                                <Close sx={{ fontSize: "18px", color: "#2196F3" }} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>



            )}


            {vendorHome && (

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    {/* <TableCell>
                                        <Checkbox size="small" style={{ color: "secondary" }}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            checked={selectedRows.length === filteredData.length}
                                            onChange={handleSelectAllClick}
                                        />
                                    </TableCell> */}
                                    <TableCell>DATE</TableCell>
                                    <TableCell>SALARY STRUCTURE NAME</TableCell>
                                    <TableCell>CREATED BY</TableCell>                                    
                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                <TextField
                                                    label="NAME"
                                                    name="name"
                                                    value={filters.name}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Company Name"
                                                    name="companyName"
                                                    value={filters.companyname}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Email"
                                                    name="email"
                                                    value={filters.email}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="WorkPhone"
                                                    name="workPhone"
                                                    value={filters.workphone}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Status"
                                                    name="status"
                                                    value={filters.status}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Payables"
                                                    name="payables"
                                                    value={filters.payales}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />

                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <TableRow key={row.id_salary_structure}>
                                        {/* <TableCell>
                                            <Checkbox
                                                size="small"
                                                checked={isSelected(row.id_salary_structure)}
                                                onChange={(event) => handleRowCheckboxClick(event, row.id_salary_structure)}
                                            />
                                        </TableCell> */}
                                        
                                       
                                        <TableCell>{row.created_date }</TableCell>
                                        <TableCell>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row.id_salary_structure,row.salary_structure_name)}
                                            >
                                                {row.salary_structure_name}
                                            </span>
                                        </TableCell>
                                        <TableCell>{row.created_by || ''}</TableCell>
                                        {/* <TableCell>{row.designation || ''}</TableCell> */}
                                        

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>
            )}




            {/* New Vendor */}
            {newVendor && (
                <>
                    <AddNewSalaryStructure handlecallback={handlecallback} editSalaryStructureID={editSalaryStructureID} editSalaryStructureCode={editSalaryStructureCode} />
                    
                </>

            )}


        </Box>
    );
}

export default SalaryStructure;